<script>
  import { onMount, tick } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, ButtonGroup, Input } from '@sveltestrap/sveltestrap';

  import { images as assets } from '@client/stores/assets';

  import AssetInput from './asset-input.svelte';
  import AssetSelect from './asset-select.svelte';
  import LogoPreview from './logo-preview.svelte';

  export let images = [];

  /**
   * Flag indicating if an image is currently being uploaded.
   * @type {boolean}
   */
  export let uploading = false;

  /**
   * The URL of the selected image.
   * @type {string | undefined}
   */
  export let value = undefined;

  const sourceOptions = [
    { label: $format('label.LOGO_CHOICE_ASSETS'), value: 'assets' },
    { label: $format('label.LOGO_CHOICE_UPLOAD'), value: 'upload' },
    { label: $format('label.LOGO_CHOICE_URL'), value: 'url' }
  ];

  let image;
  let selectedOption = 'assets';

  $: if (value && images.find((option) => option.imageurl === value)) {
    selectedOption = 'assets';
    image = images.find((option) => option.imageurl === value);
  } else if (value) {
    selectedOption = 'url';
  }

  const onUpload = async (image) => {
    // TODO should be in assets store, though complicated with current code:
    assets.update((assets) => [...assets, image]);

    // Wait until assets and asset picker are ready to set new value:
    await tick();
    value = image.imageurl;
  };

  const onRemove = () => {
    image = undefined;
    value = undefined;
  };

  onMount(() => {
    if (images.find((option) => option.imageurl === value)) {
      selectedOption = 'assets';
    } else if (value) {
      selectedOption = 'url';
    }
  });
</script>

<ButtonGroup size="sm" class="w-100 mb-3">
  {#each sourceOptions as option}
    <Button active={selectedOption === option.value} on:click={() => (selectedOption = option.value)}>
      {option.label}
    </Button>
  {/each}
</ButtonGroup>

<!-- Pick from Assets -->
<div class:d-none={selectedOption !== 'assets'}>
  <AssetSelect {images} bind:value />
</div>

<!-- Upload -->
<div class:d-none={selectedOption !== 'upload'}>
  <AssetInput bind:uploading onChange={onUpload} onPreview={(previewImage) => (image = previewImage)} />
</div>

<!-- URL -->
<div class:d-none={selectedOption !== 'url'}>
  <!-- TODO consider getting image info from on:load event -->
  <Input type="text" bind:value />
</div>

{#if image || value}
  <!-- Preview -->
  <div class="mt-3">
    <LogoPreview {image} url={value} {onRemove} />
  </div>
{/if}
